module.exports = __webpack_public_path__ + "img/emularity_splash_image.0e3cb3ed.svg";